import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=f46b9ba2&scoped=true&"
import script from "./EmptyView.vue?vue&type=script&lang=js&"
export * from "./EmptyView.vue?vue&type=script&lang=js&"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=f46b9ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46b9ba2",
  null
  
)

export default component.exports